import { useEffect } from 'react';
import { useTexts } from 'utils/useTexts';

export const useAlertWhenUserLeaves = () => {
  const { t } = useTexts();

  useEffect(() => {
    const beforeUnloadHandler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      const message = `${t('alertWhenUserLeaves.startText')} ${t('contactPhoneNumber')} ${t('alertWhenUserLeaves.endText')}`;
      event.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', beforeUnloadHandler, { capture: true });

    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler, { capture: true });
    };
  }, []);
};
